import React, { useEffect, useState } from "react";
import MuseumExhibits from "../../components/Home/museumExhibits";
import VistorInfo from "../../components/Home/vistorInfo";
import { ColorRing } from "react-loader-spinner";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { useQuery } from "@tanstack/react-query";
import { getHomePageData } from "../../services/homeServices";
import "./home-style.css";
import { Link } from "react-router-dom";
import ImageGallery from "../../components/imagegallery/ImageGallery";
import MainAttractions from "../../components/Home/MainAttractions";
import { getLightShows } from "../../services/lightShowServices";
import { getLangIdFromCode } from "../../services/langUtils";
import GalleryImages from "../../components/imagegallery/GalleryImages";

const Home = ({ language }) => {
  const textContent = {
    en: {
      MuseumataGlanceHeading: "Museum at a Glance",
      MuseumataGlancedescription:
        "To know the true soul of bharat , you need to know Mahabharat. With this thought in mind the Museum of Mahahbharat has been created to engage audience in its layered stories and immersive technologies . Worlds first dynamic museum in Jyotisar , that will take your experience to a new pinnacle.",
      MainAttractionsHeading: "Main Attractions",
      Lightandsoundshow: "Light and sound show",
      AbhigyanShakuntalam: "Abhigyan Shakuntalam",
      AbhigyanShakuntalamDec:
        'The story of Shakuntala will come alive highlighting the virtues of patience, forgiveness, and the resilience of the human spirit. Discover how India came to be known as "Bharatavarsha" named after Bharata- a brave and powerful ruler',
      MahabharatkaMahanayak: "Saraswati",
      MahabharatkaMahanayakDec:
        "In this Sound and Light Show, Goddess Saraswati herself appears as the narrator — the eternal embodiment of knowledge, music, and creation. She takes the audience on a timeless journey — from the dawn of creation through the Vedas, Puranas, and the Mahabharata, past the banks where the Indus–Saraswati Civilization once flourished, to the sacred confluence at Prayag Sangam, where her presence is still felt during the Kumbh Mela. Her voice embodies the eternal spirit of India — where culture, philosophy, and faith flow as one unbroken stream.",
      MuseumJourneyH: "Museum Journey",
      MuseumGalleriesH: "Museum Galleries",
      bookTIcketBtn: "Book Tickets",
    },
    hi: {
      MuseumataGlanceHeading: "संग्रहालय की एक झलक",
      MuseumataGlancedescription:
        "भारत की सच्ची आत्मा को जानने के लिए, आपको महाभारत को जानना होगा। इसी सोच को ध्यान में रखते हुए महाभारत संग्रहालय बनाया गया है, ताकि दर्शकों को इसकी परतदार कहानियों और इमर्सिव तकनीकों से जोड़ा जा सके। ज्योतिसर में दुनिया का पहला गतिशील संग्रहालय, जो आपके अनुभव को एक नए शिखर पर ले जाएगा।",
      MainAttractionsHeading: "मुख्य आकर्षण",
      Lightandsoundshow: "लाइट एंड साउंड शो",
      AbhigyanShakuntalam: "अभिज्ञान शाकुंतलम",
      AbhigyanShakuntalamDec:
        'शकुंतला की कहानी धैर्य, क्षमा और मानवीय भावना के लचीलेपन के गुणों को उजागर करते हुए जीवंत हो जाएगी। जानें कि कैसे भारत को "भारतवर्ष" के नाम से जाना जाने लगा, जिसका नाम भरत के नाम पर रखा गया - एक बहादुर और शक्तिशाली शासक। ',
      MahabharatkaMahanayak: "सरस्वती",
      MahabharatkaMahanayakDec:
        "इस साउंड एंड लाइट शो में देवी सरस्वती स्वयं वक्ता बनकर प्रकट होती हैं — ज्ञान, संगीत और सृजन की आदि शक्ति के रूप में। वह दर्शकों को युगों की यात्रा पर ले जाती हैं — सृष्टि से लेकर वेदों, पुराणों, और महाभारत तक, जहाँ उनकी ही पवित्र धारा के तट पर सिन्धु–सरस्वती सभ्यता फली-फूली, और जहाँ आज भी प्रयाग के संगम में कुम्भ के समय उनकी उपस्थिति अनुभव की जाती है। उनकी वाणी भारत की उस सनातन धारा को अभिव्यक्त करती है — जहाँ संस्कृति, दर्शन और आस्था एकाकार हैं।",
      MuseumJourneyH: "संग्रहालय यात्रा",
      MuseumGalleriesH: "संग्रहालय गैलरी",
      bookTIcketBtn: "टिकट खरीदें",
    },
  };

  const videoContent = {
    en: {
      museumTour: {
        videoId: "K7GS8drkaYs",
        coverImage: "/images/tour-video-cover.jpg",
      },
      museumJourney: {
        videoId: "IxNKPmu5Ew0",
        coverImage: "/images/museum-joirney-cover.jpg",
      },
    },
    hi: {
      museumTour: {
        videoId: "bNhX0nJm_RI",
        coverImage: "/images/tour-video-cover.jpg",
      },
      museumJourney: {
        videoId: "IxNKPmu5Ew0",
        coverImage: "/images/museum-joirney-cover.jpg",
      },
    },
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  const { data, isLoading, isError, error } = useQuery({
    // queryKey: ["home"],
    queryKey: ["home", language],
    queryFn: ({ signal }) => getHomePageData(signal),
  });

  const langId = getLangIdFromCode(language);

  const {
    data: lightShows,
    isLoading: isLightShowsLoading,
    isError: isLightShowsError,
    error: lightShowsError,
  } = useQuery({
    queryKey: ["lightShows", langId],
    queryFn: ({ signal }) => getLightShows({ langId }, signal),
  });

  const heroslide = {
    margin: 0,
    responsiveClass: true,
    nav: true,
    dots: false,
    autoplay: true,
    loop: true,
    autoplayTimeout: 3000,
    animateOut: "fadeOut",
    mouseDrag: false,
    touchDrag: false,
    responsive: {
      0: { items: 1 },
      600: { items: 1 },
      1000: { items: 1 },
    },
  };

  const showslider = {
    margin: 0,
    responsiveClass: true,
    nav: true,
    dots: false,
    //autoplay: true,
    loop: true,
    autoplayTimeout: 3000,
    animateOut: "fadeOut",
    mouseDrag: false,
    touchDrag: false,
    responsive: {
      0: { items: 1 },
      600: { items: 1 },
      1000: { items: 1 },
    },
  };

  const [isPlaying, setIsPlaying] = useState(false);
  const [isJourneyPlaying, setIsJourneyPlaying] = useState(false);

  const handlePlayClick = () => {
    setIsPlaying(true);
  };

  const handleJourneyPlayClick = () => {
    setIsJourneyPlaying(true);
  };

  if (isLoading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "700px" }}
      >
        <ColorRing
          visible={true}
          height="80"
          width="80"
          ariaLabel="color-ring-loading"
          wrapperStyle={{}}
          wrapperClass="color-ring-wrapper"
          colors={["#e15b64", "#f47e60", "#f8b26a", "#abbd81", "#849b87"]}
        />
      </div>
    );
  }

  if (data) {
    const currentVideoContent = videoContent[language];

    return (
      <>
        <div className="main-slider">
          <div className="carousel-container">
            <OwlCarousel className="owl-theme" {...heroslide}>
              <div className="item">
                <img src="/images/hero-slide-1.jpg" alt="" />
              </div>
              <div className="item">
                <img src="/images/hero-slide-2.jpg" alt="" />
              </div>
              <div className="item">
                <img src="/images/hero-slide-3.jpg" alt="" />
              </div>
              <div className="item">
                <img src="/images/hero-slide-4.jpg" alt="" />
              </div>
              <div className="item">
                <img src="/images/hero-slide-5.jpg" alt="" />
              </div>
              <div className="item">
                <img src="/images/hero-slide-6.jpg" alt="" />
              </div>
            </OwlCarousel>
          </div>
        </div>

        <section id="museum-at-a-glance" className="MuseumataGlance">
          <h2>{textContent[language].MuseumataGlanceHeading}</h2>
          <p>{textContent[language].MuseumataGlancedescription}</p>

          <div className="museum-image">
            <img src="/images/museum-glance.jpg" alt="" />
          </div>
        </section>

        <section id="museum-tour" className="museum-tour">
          <div className="container">
            <div className="video-tour">
              <div className="border-image">
                <img src="/images/video-border-frame.svg" alt="" />
              </div>
              <div
                className={`video-frame ${isPlaying ? "open" : ""}`}
                onClick={handlePlayClick}
              >
                {!isPlaying && (
                  <div className="cover-image">
                    <img
                      src={currentVideoContent.museumTour.coverImage}
                      alt=""
                    />
                    <span className="play-video-trigger">
                      <img src="/images/videoplay-icon.svg" alt="" />
                    </span>
                  </div>
                )}
                <iframe
                  src={`https://www.youtube.com/embed/${currentVideoContent.museumTour.videoId}?rel=0&showinfo=0${isPlaying ? "&autoplay=1" : ""}`}
                  frameBorder="0"
                  allowFullScreen
                  title="Museum Tour Video"
                ></iframe>
              </div>
            </div>
          </div>
        </section>

        {/* {
            data.uniqueBlocksExhibits && <MuseumExhibits homeExhibits={data.uniqueBlocksExhibits} language={language} />
          } */}

        {/* Dynamic Main Attractions */}
        <MainAttractions language={language} />

        {!isLightShowsError && lightShows && lightShows.length > 0 && (
          <div id="light-sound-show" className="show-slider">
            <div className="section-heading">
              <h2>{textContent[language].Lightandsoundshow}</h2>
            </div>
            <div className="carousel-container with-custom-arrow">
              <OwlCarousel className="owl-theme" {...showslider} key={language}>
                {lightShows.map((show) => (
                  <div className="item" key={show.id}>
                    <img
                      src={show.image || "/images/show-image-1.jpg"}
                      alt={show.name}
                    />
                    <div className="slider-caption">
                      <div className="container">
                        <h3>{show.name}</h3>
                        <p>{show.description || show.body}</p>
                        <Link to="http://Jyotisar.haryanatourism.co.in">
                          {textContent[language].bookTIcketBtn}
                        </Link>
                      </div>
                    </div>
                  </div>
                ))}
              </OwlCarousel>
            </div>
          </div>
        )}

        <section id="museum-journey" className="museum-journey museum-tour">
          <div className="container">
            <h3>{textContent[language].MuseumJourneyH}</h3>
            <div className="video-tour">
              <div className="border-image">
                <img src="/images/video-border-frame.svg" alt="" />
              </div>
              <div
                className={`video-frame ${isJourneyPlaying ? "open" : ""}`}
                onClick={handleJourneyPlayClick}
              >
                {!isJourneyPlaying && (
                  <div className="cover-image">
                    <img
                      src={currentVideoContent.museumJourney.coverImage}
                      alt=""
                    />
                    <span className="play-video-trigger">
                      <img src="/images/videoplay-icon.svg" alt="" />
                    </span>
                  </div>
                )}
                <iframe
                  src={`https://www.youtube.com/embed/${currentVideoContent.museumJourney.videoId}?rel=0&showinfo=0${isJourneyPlaying ? "&autoplay=1" : ""}`}
                  frameBorder="0"
                  allowFullScreen
                  title="Museum Journey Video"
                ></iframe>
              </div>
            </div>
          </div>
        </section>

        <section id="museum-galleries" className="MuseumGalleries">
          <div className="container">
            <h2>{textContent[language].MuseumGalleriesH}</h2>
          </div>
          <div className="container">
            <GalleryImages language={language} />
          </div>
        </section>

        <VistorInfo language={language} />
      </>
    );
  }

  if (isError) {
    return <div style={{ textAlign: "center" }}>{error.message}</div>;
  }
};

export default Home;
